import { render, staticRenderFns } from "./RevisionExitConfigurationCrud.vue?vue&type=template&id=2f9dc7b2&scoped=true"
import script from "./RevisionExitConfigurationCrud.vue?vue&type=script&lang=js"
export * from "./RevisionExitConfigurationCrud.vue?vue&type=script&lang=js"
import style0 from "./RevisionExitConfigurationCrud.vue?vue&type=style&index=0&id=2f9dc7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9dc7b2",
  null
  
)

export default component.exports